import { registerComponent } from '@gig/magic-common';
import PWAInstallPopupComponent from './pwa-install-popup.js';

var PWAInstallPopup = registerComponent(PWAInstallPopupComponent);

export { PWAInstallPopup };
